import * as React from "react";
import { ComponentProps } from "react";
import { isNil } from "ramda";

import { ConfirmField } from "../confirm";

const parseValue: ComponentProps<typeof ConfirmField>["parseValue"] = (value) =>
  !isNil(value) ? value.replace(/\D/g, "") : value;

export const NHSNumberField: React.FC<React.ComponentProps<typeof ConfirmField>> = ({ ...props }) => {
  return <ConfirmField {...props} parseValue={parseValue} />;
};
